import { v4 as uuidv4 } from "uuid"

export const footer = [
  {
    id: uuidv4(),
    title: "Home",
    url: "/",
  },
  {
    id: uuidv4(),
    title: "Services",
    url: "/services",
  },
]
